import * as React from "react";
import type { SVGProps } from "react";
const SvgCigarette = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19 9.5c0-.55-.45-1-1-1-1.65 0-3-1.35-3-3V5c0-.55.45-1 1-1s1 .45 1 1v.5c0 .55.45 1 1 1 1.65 0 3 1.35 3 3v.5c0 .55-.45 1-1 1s-1-.45-1-1zM4 12h16c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-2c0-1.1.9-2 2-2m3 2H4v2h3zm2 2h11v-2H9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCigarette;
